import { transformSimplifiedQueryResult } from '@/domain/common/query'
import { useOngoingCampaignsQuery } from '@/features/spark-rewards/data/useOngoingCampaignsQuery'
import { MarketSparkRewards } from '@/features/spark-rewards/types'
import { assignMarketSparkRewards } from '@/features/spark-rewards/utils/assignMarketSparkRewards'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'

export interface UseSparkRewardsParams {
  chainId: number
  reserve: Reserve
}

export type UseSparkRewardsResult = MarketSparkRewards[]

export function useSparkRewards({ chainId, reserve }: UseSparkRewardsParams): UseSparkRewardsResult {
  const ongoingCampaignsResult = useOngoingCampaignsQuery()

  const { data } = transformSimplifiedQueryResult(ongoingCampaignsResult, (data) => {
    const campaigns = data
      .filter((campaign) => campaign.type === 'sparklend')
      .filter((campaign) => campaign.chainId === chainId)
    return [
      ...assignMarketSparkRewards({
        campaigns,
        action: 'supply',
        reserveTokenSymbol: reserve.token.symbol,
        chainId,
      }),
      ...assignMarketSparkRewards({
        campaigns,
        action: 'borrow',
        reserveTokenSymbol: reserve.token.symbol,
        chainId,
      }),
    ]
  })

  return data ?? []
}
